<script>
  import options from './ProjectCard.options'
  export default options
</script>

<template>
  <article class="kb-project-card">
    <a :href="result.url">

      <div class="kb-project-card__content-wrapper">

        <template v-if="result?.category?.svgIcon">
          <div class="kb-project-card__icon-wrapper"
            :class="result.category.colorTheme ? result.category.colorTheme : ''" >

            <div  class="kb-project-card__icon-circle"
              v-html="result.category.svgIcon"></div>

            <p class="kb-project-card__icon-text">
              {{ result.category.title }}
            </p>
          </div>
        </template>

        <template v-if="result.label !== null">
          <div class="kb-project-card__label-wrapper" :class="result.label.colorTheme ? result.label.colorTheme : ''" >

              <p class="kb-project-card__label-text">
                {{ result.label.title }}
              </p>
  
          </div>
        </template>

        <div class="kb-project-card__texts-wrapper">

          <h2 class="kb-project-card__title">{{ result.title }}</h2>

          <p class="kb-project-card__description">
            {{ result.description }}
          </p>
          
        </div>
        
        <div class="kb-project-card__bottom-content">
          <p v-if="result.fundingAmount && !result?.statusText" class="kb-project-card__funding-amount">
            {{ result.fundingAmount.formattedString }}
          </p>
          
          <template v-if="!result.fundingAmount && result?.statusText">
            <div class="kb-project-card__funding-status-wrapper">
              <p class="kb-project-card__funding-status-text">
                {{ result.statusText }}
              </p>
            </div>
          </template>
  
          <template v-if="result.tags">
            <div class="kb-project-card__tags">
              <template v-for="(tag, index) in result.tags" :key="index">
                <div index="index">{{ tag.name }}</div>
              </template>
            </div>
          </template>

        </div>

      </div>
    
    </a>
  </article>
</template>
